module.exports = __webpack_public_path__ + "astonished.321a23c5.png";